import { render, staticRenderFns } from "./SingleSelection.vue?vue&type=template&id=2aa8f3d8&"
import script from "./SingleSelection.vue?vue&type=script&lang=js&"
export * from "./SingleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleSelection.vue"
export default component.exports